function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.22 38.13L53 43.88a1.86 1.86 0 010 2.64l-4.3 4.27a1.86 1.86 0 01-2.64 0L40.31 45a.73.73 0 00-1.21.33 12 12 0 0015.81 14.46L79.78 87a6.64 6.64 0 009.59.22 6.65 6.65 0 00-.24-9.63L61.87 53a12 12 0 00-14.32-16.08.73.73 0 00-.33 1.21zm39.31 44.32a2 2 0 11-2-2 2 2 0 012 2z",
  fill: "#8e8fa2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.61 50.48L62 52.64A12 12 0 0059.21 40c-.26-.25-.52-.5-.8-.72a12 12 0 011.2 11.2zM77.5 84.49L79.78 87a6.64 6.64 0 009.59.22 6.65 6.65 0 00-.24-9.63l-.93-.84a6.64 6.64 0 01-1.09 8 6.65 6.65 0 01-9.61-.2M54.91 59.79l-2.26-2.51a12 12 0 01-11.92-2A12.29 12.29 0 0042.2 57a12 12 0 0012.71 2.76m15.25.7l-2.11 2.12-1.42-1.42a2.25 2.25 0 00-3.18 0l-1.93 1.94a5.41 5.41 0 010 3.9l4.68 5.12a5.36 5.36 0 013.25-.41 2 2 0 001.79-.55l1.11-1.11a2.25 2.25 0 000-3.18 2 2 0 010-2.83l.84-.85z",
  fill: "#5a5a60"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91 43.09l-3.6-3.63a.74.74 0 00-1.17.17l-2 3.71-17.84 17.89 2.88 2.88 17.88-17.89 3.71-2a.73.73 0 00.14-1.13z",
  fill: "#f4f4f7"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91 43.09l-.92-.91a.74.74 0 01-.38.8l-3.7 2-17.85 17.84-1.68-1.68-.08.09 2.88 2.88 17.88-17.89 3.71-2a.73.73 0 00.14-1.13z",
  fill: "#c7cad3"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.19 71.66a5.38 5.38 0 015.74-1.21l1.93-1.93a2.25 2.25 0 000-3.18l-5.7-5.71a2.25 2.25 0 00-3.18 0L60 61.57a5.36 5.36 0 01-6.95 6.94L42.84 78.77a6.28 6.28 0 000 8.89 6.28 6.28 0 008.88 0L62 77.4a5.37 5.37 0 011.19-5.74z",
  fill: "#ffc61f"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.86 65.34L69.51 64a2.23 2.23 0 01-.58 2.14L67 68.07a5.36 5.36 0 00-6.94 7l-10.27 10.2a6.28 6.28 0 01-8.21.59 6.29 6.29 0 0010.14 1.8L62 77.4a5.37 5.37 0 017-7l1.94-1.93a2.25 2.25 0 00-.08-3.13z",
  fill: "#f4a800"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.47 82a.84.84 0 01-.59-1.43l7.93-7.93A.84.84 0 1155 73.82l-7.94 7.94a.84.84 0 01-.59.24zm2.93 2.93a.84.84 0 01-.59-1.43l7.94-7.93a.83.83 0 111.18 1.18L50 84.69a.82.82 0 01-.6.24z",
  fill: "#ff6231"
});

var SvgIcBuild = function SvgIcBuild(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcBuild as ReactComponent };